import * as Yup from 'yup';
// add validation to driver form
const loginFormSchema = Yup.object().shape({
    word: Yup.string().required('Keyword is required.'),
})

export default loginFormSchema;
